import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  icon, 
  iconColor, 
  title, 
  value, 
  unit, 
  subtitle, 
  trend, 
  trendValue,
  onClick 
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'var(--color-success)';
    if (trend === 'down') return 'var(--color-error)';
    return 'var(--color-muted-foreground)';
  };

  return (
    <div 
      onClick={onClick}
      className={`
        bg-card border border-border rounded-lg shadow-md p-4 md:p-6
        transition-smooth hover-lift hover:shadow-lg
        ${onClick ? 'cursor-pointer' : ''}
      `}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center h-10 w-10 md:h-12 md:w-12 rounded-lg bg-primary/10">
            <Icon name={icon} size={20} color={iconColor} strokeWidth={2.5} />
          </div>
          <div>
            <p className="text-xs md:text-sm caption text-muted-foreground">{title}</p>
            <div className="flex items-baseline gap-1 mt-1">
              <span className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
                {value}
              </span>
              {unit && (
                <span className="text-sm md:text-base text-muted-foreground">{unit}</span>
              )}
            </div>
          </div>
        </div>
        {trend && (
          <div className="flex items-center gap-1">
            <Icon name={getTrendIcon()} size={16} color={getTrendColor()} strokeWidth={2} />
            <span className="text-xs md:text-sm font-medium data-text" style={{ color: getTrendColor() }}>
              {trendValue}
            </span>
          </div>
        )}
      </div>
      {subtitle && (
        <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default MetricCard;